<ng-container>
    <div class="overlay-warp">
        <div class="itemx" *ngFor="let item of statusList">
            <div [ngSwitch]="item.status">
                <div class="item-list">
                    <div class="choose"  [ngClass]="{'selected': item.choosed}" (click)="selectStatus(item)">
                        <!-- (click)="addItem($event,option)" [ngClass]="{'selected': option.completed }" -->
                        <div class="inner-selected">
                            <img src="/assets/images/auto-fill/vi.svg">
                        </div>
                    </div>
                    <div *ngSwitchCase="enumQStatus.Edit" class="st edit">
                        <img src="/assets/images/grid/status/edit.svg">
                        <p translate>grid.status.edit</p>
                    </div>
                    <div *ngSwitchCase="enumQStatus.Distributed" class="st distributed">
                        <img src="/assets/images/grid/status/distributed.svg">
                        <p translate>grid.status.distributed</p>
                    </div>
                    <div *ngSwitchCase="enumQStatus.Respond" class="st respond">
                        <img src="/assets/images/grid/status/answered.svg">
                        <p translate> grid.status.replay</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>